import * as React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { useDispatch, useSelector } from 'react-redux';
import classnames from 'classnames';

import * as PreviewStore from '../../../app/store/PreviewStore';

import { TaskContent } from '../../../youwell-common/components';
import urls from '../../../app/urls';
import { parseInternalLink } from '../../../common/taskContentUtils';
import { getSpecificTaskResponses } from '../../../youwell-common/responseUtils';

const styles = () => ({
    root: {
        // Flex-display with wrap needed for card-layout on page
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',

        '@media print': {
            display: 'block',
        },
    },
});

const useStyles = makeStyles(theme => styles(theme), { name: 'PreviewTaskContent' });


const ExternalTaskContent = ({ forwardedRef, task }) => {
    const classes = useStyles();
    const dispatch = useDispatch();

    const allTaskResponses = useSelector(state => state.previewStore.responses);
    const allTasksDetails = useSelector(state => state.previewStore.details);

    // task.patientProgramElementId is "undefined" but this works.. Should maybe make more robust?
    const responsesForCurrentTask = allTaskResponses && allTaskResponses[task.patientProgramElementId]
        && allTaskResponses[task.patientProgramElementId][task.id];

    const updateResponse = (responses) => {
        const responseData = {
            taskId: task.id,
            taskVersion: task.version,
            responses,
        };

        dispatch(PreviewStore.actionCreators.updateResponse(responseData));
    };

    const saveChanges = (callback) => {
        if (callback) {
            callback();
        }
    };

    const getLinkUrl = (link) => {
        const { taskOrModuleId, hash } = parseInternalLink(link);
        return `${urls.preview.home}/${taskOrModuleId}${hash}`;
    };

    const getProgramItem = id => (allTasksDetails ? allTasksDetails[id] : null);

    return (
        <TaskContent
            ref={forwardedRef}
            className={classnames(classes.root)}
            LinkElementProps={{
                getLinkUrl,
                // autoplayVideos: clientConfig.appSetup.features.autoplayVideos,
            }}
            task={task}
            taskResponses={responsesForCurrentTask}
            getProgramItem={getProgramItem}
            getSpecificTaskResponses={getSpecificTaskResponses(allTaskResponses, responsesForCurrentTask)}
            onResponse={updateResponse}
            onSaveChanges={saveChanges}
        />
    );
};

ExternalTaskContent.propTypes = {
    forwardedRef: PropTypes.object,
    task: PropTypes.object.isRequired,
};

ExternalTaskContent.defaultProps = {
    forwardedRef: null,
};

const WithRef = React.forwardRef((props, ref) => <ExternalTaskContent {...props} forwardedRef={ref} />);
export default WithRef;
